module.exports = __webpack_public_path__ + "img/EnrollmentTypes.c1a5dd95.svg";